<template>
  <div id="app">
    <div id="nav">
      <img src="./assets/logo.png" alt="logo" id="nav_pic" style="cursor: pointer" @click="goBackHome">
      <div class="my-div-center" id="nav_word">
        <h1 style="margin-left: 10px">
          Welcome to CancerSRT!
        </h1>
      </div>
<!--      <h1 id="head">-->
<!--        &nbsp;&nbsp;&nbsp;&nbsp;Welcome to Human Cancer SRT Database!-->
<!--      </h1>-->
      <div id="nav_menu">
        <el-menu
            id="my-menu"
            :default-active="activeIndex"
            text-color="#FFFFFF"
            active-text-color="#000000"
            mode="horizontal"
            router>
          <el-menu-item index="/Home">
            <i class="el-icon-s-home"></i>Home
          </el-menu-item>
          <!--        <el-menu-item index="/Home" style="font-size: 20px"><i class="el-icon-location"></i><b>Home</b></el-menu-item>-->
          <el-menu-item index="/Browse">
            <i class="el-icon-view"></i>Statistics
          </el-menu-item>
          <el-menu-item index="/Search">
            <i class="el-icon-search"></i>Search
          </el-menu-item>
          <el-menu-item index="/Dataset">
            <i class="el-icon-s-data"></i>Dataset
          </el-menu-item>
<!--          <el-menu-item index="/Explorer">-->
<!--            <i class="el-icon-discover"></i>Cancer explorer-->
<!--          </el-menu-item>-->
          <el-menu-item index="/PanCancer">
            <i class="el-icon-discover"></i>PanCancer
          </el-menu-item>
          <el-menu-item index="/Download">
            <i class="el-icon-share"></i>Share
          </el-menu-item>
          <el-menu-item index="/CalDataset">
            <i class="el-icon-cpu"></i>Calculate
          </el-menu-item>
          <el-menu-item index="/Help">
            <i class="el-icon-question"></i>Help
          </el-menu-item>
          <!--      <el-menu-item index="/Compare">Compare</el-menu-item>-->
        </el-menu>
      </div>
    </div>

<!--    <h1 style="height: 32px;margin-top: 4px;margin-bottom: 4px">-->
<!--      &nbsp;&nbsp;&nbsp;&nbsp;Welcome to Human Cancer SRT Database!-->
<!--    </h1>-->

<!--    <div style="background-color: aquamarine; width: 100%">-->
<!--      <router-view/>-->
<!--    </div>-->

    <div id="main_component">
<!--      <div style="width: 100%;border: #696969 solid 1px;border-radius:5px;">-->
      <router-view/>
    </div>

<!--    <footer style="background-color: lawngreen">For questions and suggestions, please contact: huoyuying<br>© Human Cancer Spatial Database.</footer>-->
    <footer id="footer">
      CancerSRT © 2023 Created by LiXY Group, School of Software Engineering, Beijing Jiaotong University.
      For questions and suggestions, please contact: 21121732@bjtu.edu.cn
      <br/>
      <a href="https://beian.miit.gov.cn/" target="_blank" style="color: #000000;text-decoration:none;">晋ICP备2023000713号-1</a>
      <a target="_blank" style="color: #000000;text-decoration:none;" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=14100202000378">晋公网安备 14100202000378号</a>
      &nbsp;
<!--      <a target="_blank" style="color: #000000;text-decoration:none;" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=14100202000378"><img src="./assets/beian.png" height="15px"/>晋公网安备 14100202000378号</a>-->
    </footer>
  </div>
</template>

<script>

export default {
  name: 'App',
  data(){
    return {
      activeIndex: ''
    }
  },
  watch: {
    // 监听路由变化

    '$route.path': {
      handler (routePath) {
        this.initMenuActive(routePath)
      },
      immediate: true
    }
  },
  created(){
    let dataset_patt = "/Dataset"
    if (this.$route.path === '/Home') {
      this.activeIndex = '/Home'
    } else if(this.$route.path === '/Browse'){
      this.activeIndex = '/Browse'
    } else if(this.$route.path === '/Search'){
      this.activeIndex = '/Search'
    } else if(this.$route.path.match(dataset_patt) !== null){
      this.activeIndex = '/Dataset'
    } else if(this.$route.path === '/Explorer'){
      this.activeIndex = '/Explorer'
    } else if(this.$route.path === '/Upload'){
      this.activeIndex = '/Upload'
    } else if(this.$route.path === '/Download'){
      this.activeIndex = '/Download'
    } else if(this.$route.path === '/Help'){
      this.activeIndex = '/Help'
    } else {
      this.activeIndex = '/Home'
    }
  },
  methods: {
    initMenuActive (routePath) {
      let dataset_patt = "/Dataset"
      console.log("routePath",routePath)
      if(routePath === '/Help'){
        console.log('asd')
        // document.getElementById('main_component').style.width = "100%"
      }
      //路由跳转时，标记在导航的哪个选项下对应的路由，css高亮显示
      if (routePath === '/Home') {
        this.activeIndex = '/Home'
      } else if(routePath === '/Browse'){
        this.activeIndex = '/Browse'
      } else if(routePath === '/Search'){
        this.activeIndex = '/Search'
      } else if(routePath.match(dataset_patt) !== null){
        this.activeIndex = '/Dataset'
      } else if(routePath === '/Explorer'){
        this.activeIndex = '/Explorer'
      } else if(routePath === '/Upload'){
        this.activeIndex = '/Upload'
      } else if(routePath === '/Download'){
        this.activeIndex = '/Download'
      } else if(routePath === '/Help'){
        this.activeIndex = '/Help'
      }
    },
    goBackHome(){
      this.$router.push({
        path: '/Home'
      });
    },
  }
}
</script>

<style>
#app {
  font-family: Arial, serif;
  /*font-family: Avenir, Helvetica, Arial, sans-serif;*/
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

  position: absolute;
  /*overflow: scroll;*/
  /*position: absolute;*/
  left: 50%;
  transform: translateX(-50%); /* 移动元素本身50% */

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  width: 100%;
  min-height: 100%;
  min-width: 1500px;
  /*background-color: azure;*/
}

#my-menu {
  /*width: 800px;*/
  height: 100px;
  margin: 0;
  padding: 0;
  border: none;
  background-color: #252746;
}
/*#my-menu .el-menu--horizontal > .el-menu-item {*/
/*  border-bottom: none;*/
/*  text-decoration: none;*/
/*}*/
#my-menu .el-menu-item{
  height: 100px;
  line-height: 100px;
  /*height: 100px;*/
  text-align: center;
  margin: 0;
  padding: 0 10px 0 10px;
  border: none;
  /*border-bottom: none !important;*/
  /*padding: 20px 10px;*/
  /*border-bottom: none;*/
  /*text-decoration: none;*/
  font-size: 14px;
  font-weight: bold;
  background-color: #252746;
  /*color: #808080*/
}

#my-menu .el-menu-item.is-active {
  /*background-color: #1e80be !important;*/
  color: yellow !important;
  /*color: #808080 !important;*/
  font-size: 16px;
  /*height:  !important;*/
  /*border-bottom: none;*/
  /*border-bottom: none;*/
  /*text-decoration: none;*/
}

#my-menu .el-menu-item:hover {
  /*background-color: #00BFFF;*/
  /*background-color: #3F78C1;*/
  color: #FFFF00 !important;
  /*font-size: 25px;*/
  /*border-bottom: none;*/
}

#my-menu .el-menu-item:hover i{
  color: #FFFF00 !important;
}

#nav {
  position: sticky;
  /*position: fixed;*/
  text-align: left;
  width: 100%;
  height: 100px;
  z-index: 999;
  min-width: 1500px;
  top: 0;
  /*margin-bottom: 10px;*/
  display: flex;
  /*flex-direction: row;*/
  /*justify-content: center;*/
  /*align-items: stretch;*/
  /*position: fixed;*/
  /*border: #696969 solid 1px;*/
  /*border-radius:5px;*/
  background-color: #252746;
}
#nav_pic {
  padding-left: 10%;
}
#nav_word{
  flex: 1;
  color: #FFFFFF;
}
#nav_menu{
  overflow-x: auto;
  overflow-y: auto;
  padding-right: 10%;
  height: 100px;
}

#main_component{
  flex: 1;
  width: 1350px;
  padding: 0;
  margin: 0;

  /*min-width: 1000px;*/
  /*max-width: 1200px;*/
}

#sidebar {
  background: lightgray;
  padding: 0;
  position: fixed;
  top: 52px;
  bottom: 0;
}

.my-container {
  /*border: #696969 solid 1px;*/
  /*border-radius:5px;*/
  margin: 10px 0 10px 0;
  padding: 0;
  background-color: #FFFFFF;
}
/*.my-container div{*/
/*  margin: 10px;*/
/*}*/

.my-div-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

h2 {
  /*background-color: #d9edf7;*/
  color: #000000;
  background-color: #CFCFCF;
  height: 30px;
  line-height: 30px;
  text-align: center;
  /*border: #696969 solid 1px;*/
  border-radius:5px;
  margin: 0;
  padding: 0;
    /*background-color: beige;*/
}


#footer {
  position: sticky;
  /*position: fixed;*/
  height: 40px;
  font-size: 10px;
  /*background-color: #004242;*/
  background-color: #252746;
  color: #FFFFFF;
  width: 100%;
  bottom: 0;
  z-index: 99;
  line-height: 20px;
}

</style>
